import { logUtil } from 'packages/src'
import loadByRecommendedIdWorkoutAction from 'modules/workout/redux/actions/load-recommended-by-id/index.js'

/**
 * Loads a recommended workout.
 * This route is now only used for recommended workouts from the workout library.
 * Workouts in plans use the PLAN_WORKOUT_BY_ID_SLUG route instead.
 *
 * @param id
 * @param match
 * @param rest
 * @returns {(function(*, *): void)|*}
 */
export function performLoadByIdWorkoutAction ({
  id,
  match
}) {
  return async (dispatch) => {
    const idFromSSR = match?.params?.id
    id = id || idFromSSR

    logUtil('performLoadByIdWorkoutAction').debug('call loadByRecommendedIdWorkoutAction', { id })
    await dispatch(loadByRecommendedIdWorkoutAction({ id }))
  }
}
